import type { Order } from 'src/types/types';

import { STATUS } from 'src/types/types';

// Statusser hvor en ordre reelt regnes som bekræftet/afsluttet og lægger beslag på lageret.
// Kladde og Tilbud er ikke bekræftede endnu og tæller derfor ikke med.
export const CONFIRMED_ORDER_STATUSES: STATUS[] = [
  STATUS.BEKRÆFTET,
  STATUS.UDE,
  STATUS.BETALING,
  STATUS.AFSLUTTET,
];

// Antal registrerede erstatninger pr. erstatningsprodukt, kun fra afsluttede ordrer,
// til fradrag i det oprindelige produkts varebeholdning.
export function getReplacedQuantityByProductId(orders: Order[]): Map<number, number> {
  const map = new Map<number, number>();

  orders
    .filter((order) => order.status === STATUS.AFSLUTTET)
    .forEach((order) => {
      order.orderLines.forEach((line) => {
        if (line.product?.category === 'erstatning') {
          map.set(line.product.id, (map.get(line.product.id) ?? 0) + line.quantity);
        }
      });
    });

  return map;
}
